import { Tooltip } from "react-tooltip";
import MinimalEditor from "../editor/MinimalEditor";

function AnswerInput({ preventDragDrop, value, onChange, index, assignment_id, currentStep, assignmentType, isRecording = false ,onMathKeyboardToggle }) {

  const disableStyle = isRecording ? { pointerEvents: 'none', opacity: 0.5 } : {};

  return (
    <>
      <div className="AssingmentMCQs-mock-test-answer-container" style={disableStyle}>
        <div className="options AssignmentMCQs-mock-test-answer-container">
          <div className="option AssignmentMCQs-mock-test-answer-folder">
            <MinimalEditor
              preventDragDrop={preventDragDrop}
              value={value}
              onChange={onChange}
              placeholder="Start typing..."
              index={index}
              assignment_id={assignment_id}
              currentStep={currentStep}
              assignmentType={assignmentType}
                            onMathKeyboardToggle={onMathKeyboardToggle}
            />
            <Tooltip
              id="math-tooltip"
              place="top"
              effect="solid"
              type="light"
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default AnswerInput;